export enum ESubscriptionPeriod {
    Week = 1,
    Month = 2,
    Year = 3,
}

export interface IUserSubscriptionInfo {
    /** 1-周，2-月，3-年 */
    period: string;
    /** 开始日期（时间戳） */
    valid_from: number;
    /** 结束日期（时间戳） */
    valid_until: number;
    /** 描述： 如 */
    description?: string;
}

export interface IWalletBalanceInfo {
    /** 购买代币 */
    coins: number;
    /** 赠送代币 */
    vouchers: number;
}

export interface IUserInfoResponseData {
    user_subscription_info: IUserSubscriptionInfo;
    wallet_balance_info: IWalletBalanceInfo;
    is_vip: boolean;
}

// ----------------------------- top-up -----------------------------
/** 记录筛选类型 */
export enum EAddedRecordFilterType {
    All = 0,
    Recharge = 1,
    Subscription = 2,
    Reward = 3,
    Expired = 6,
}

/** 记录真实类型 */
export enum EAddedRecordType {
    Recharge = 1,
    Subscription = 2,
    Reward = 3,
    RechargeRefund = 4,
    SubscriptionRefund = 5,
}

/** 支付状态 */
export enum EPayStatus {
    Completed = 1,
    Refund = 2,
}

/** 支付渠道来源（app_base.SourceType） */
export enum ESourceType {
    Stripe = 1,
    PayPal = 2,
}

export interface IGetAddedListRequest {
    /** 请求携带上次返回的 cursor */
    cursor?: string;
    /** 每页请求的数据量，默认 10 */
    page_size?: number;
    /** 0: 全部 1: 充值 2: 订阅 3: 奖励 4: 过期 */
    record_type?: EAddedRecordFilterType;
}

export interface IAddedRecordItem {
    /** 记录类型：1充值、2订阅、3奖励、4充值退款、5订阅退款 */
    record_type: EAddedRecordType;
    /** 金币变动量 */
    coin_delta?: number;
    /** 代金券变动量 */
    voucher_delta?: number;
    /** 价格 */
    price?: string;
    /** 会员时长：周/月/年卡会员 Weekly Pass */
    period?: string;
    /** 周期描述：周/月/年 */
    description?: string;
    /** 生效时间（毫秒时间戳） */
    valid_from?: number;
    /** 失效时间（毫秒时间戳） */
    valid_until?: number;
    /** 子标题 */
    sub_title?: string;
    /** 订单 ID */
    order_id?: string;
    /** 支付状态：1 completed 2 refund */
    pay_status?: EPayStatus;
    /** 支付渠道来源 */
    source_type?: ESourceType;
    /** 自动续费：1=开启，0=关闭 */
    auto_renew?: 0 | 1;
    /** 原始交易 ID */
    original_transaction_id?: string;
}

export interface IGetAddedListResponseData {
    /** 金币获取记录列表 */
    record_list?: IAddedRecordItem[];
    /** 下一页游标 */
    cursor: string;
    /** 是否还有下一页 */
    has_next: boolean;
}

export interface ICancelSubscriptionRequest {
    original_transaction_id: string;
}

// ----------------------------- used_list -----------------------------
export interface IGetUsedListRequest {
    /** 请求携带上次返回的 cursor */
    cursor?: string;
    /** 每页请求的数据量，默认 10 */
    page_size?: number;
}

export interface IChapterConsumptionItem {
    /** 短剧 ID */
    drama_id: string;
    /** 章节 ID */
    chapter_id: string;
    /** 短剧标题 */
    drama_title: string;
    /** 短剧封面 URL */
    drama_cover_url: string;
    /** 集数排序（第几集） */
    sort_no: number;
    /** 金币变动量（正数=增加，负数=减少） */
    coin_delta: number;
    /** 代金券变动量（正数=增加，负数=减少） */
    voucher_delta: number;
    /** 创建时间（毫秒时间戳） */
    created_at: number;
}

export interface IGetUsedListResponseData {
    /** 剧集消费记录列表（按创建时间降序） */
    consumption_list?: IChapterConsumptionItem[];
    /** 下一页游标 */
    cursor: string;
    /** 是否还有下一页 */
    has_next: boolean;
}
